"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorNotificationTime = exports.dateSearchCharacter = exports.cloneNamePrefix = exports.translatedStrings = exports.LoadPolicyDataType = exports.CloneRolesDetailsType = exports.cloneRolesListType = exports.clonePermissionsListType = exports.ClonePermissionActionsType = exports.ClonePermissionDetailsType = exports.CloneNotificationType = exports.ClonePolicyType = exports.CloneTokensType = exports.CloneServiceIdentitiesType = exports.CloneGroupsType = exports.CloneUsersType = exports.CloneFetchServiceIdentityType = exports.CloneFetchTokenType = exports.CloneFetchGroupType = exports.CloneFetchUserType = void 0;

var _externalization = require("../../../packages/policy-management/externalization");

var CloneFetchUserType = {
  FETCH_USER_REQUEST: 'FETCH_USER_REQUEST',
  FETCH_USER_REQUEST_LOADING: 'FETCH_USER_REQUEST_LOADING',
  FETCH_USER_REQUEST_SUCCESS: 'FETCH_USER_REQUEST_SUCCESS',
  FETCH_USER_REQUEST_FAILURE: 'FETCH_USER_REQUEST_ERROR'
};
exports.CloneFetchUserType = CloneFetchUserType;
var CloneFetchGroupType = {
  FETCH_GROUP_REQUEST: 'FETCH_GROUP_REQUEST',
  FETCH_GROUP_REQUEST_LOADING: 'FETCH_GROUP_REQUEST_LOADING',
  FETCH_GROUP_REQUEST_SUCCESS: 'FETCH_GROUP_REQUEST_SUCCESS',
  FETCH_GROUP_REQUEST_FAILURE: 'FETCH_GROUP_REQUEST_ERROR'
};
exports.CloneFetchGroupType = CloneFetchGroupType;
var CloneFetchTokenType = {
  FETCH_TOKEN_REQUEST: 'FETCH_TOKEN_REQUEST',
  FETCH_TOKEN_REQUEST_LOADING: 'FETCH_TOKEN_REQUEST_LOADING',
  FETCH_TOKEN_REQUEST_SUCCESS: 'FETCH_TOKEN_REQUEST_SUCCESS',
  FETCH_TOKEN_REQUEST_FAILURE: 'FETCH_TOKEN_REQUEST_ERROR'
};
exports.CloneFetchTokenType = CloneFetchTokenType;
var CloneFetchServiceIdentityType = {
  FETCH_SERVICE_IDENTITY_REQUEST: 'FETCH_SERVICE_IDENTITY_REQUEST',
  FETCH_SERVICE_IDENTITY_REQUEST_LOADING: 'FETCH_SERVICE_IDENTITY_REQUEST_LOADING',
  FETCH_SERVICE_IDENTITY_REQUEST_SUCCESS: 'FETCH_SERVICE_IDENTITY_REQUEST_SUCCESS',
  FETCH_SERVICE_IDENTITY_REQUEST_FAILURE: 'FETCH_SERVICE_IDENTITY_REQUEST_ERROR'
};
exports.CloneFetchServiceIdentityType = CloneFetchServiceIdentityType;
var CloneUsersType = {
  CLONE_USERS_REQUEST: 'CLONE_USERS_REQUEST',
  CLONE_USERS_LOADING: 'CLONE_USERS_LOADING',
  CLONE_USERS_SUCCESS: 'CLONE_USERS_SUCCESS',
  CLONE_USERS_FAILURE: 'CLONE_USERS_ERROR'
};
exports.CloneUsersType = CloneUsersType;
var CloneGroupsType = {
  CLONE_GROUPS_REQUEST: 'CLONE_GROUPS_REQUEST',
  CLONE_GROUPS_LOADING: 'CLONE_GROUPS_LOADING',
  CLONE_GROUPS_SUCCESS: 'CLONE_GROUPS_SUCCESS',
  CLONE_GROUPS_FAILURE: 'CLONE_GROUPS_FAILURE'
};
exports.CloneGroupsType = CloneGroupsType;
var CloneServiceIdentitiesType = {
  CLONE_SERVICE_IDENTITY_REQUEST: 'CLONE_SERVICE_IDENTITY_REQUEST',
  CLONE_SERVICE_IDENTITY_LOADING: 'CLONE_SERVICE_IDENTITY_LOADING',
  CLONE_SERVICE_IDENTITY_SUCCESS: 'CLONE_SERVICE_IDENTITY_SUCCESS',
  CLONE_SERVICE_IDENTITY_FAILURE: 'CLONE_SERVICE_IDENTITY_FAILURE'
};
exports.CloneServiceIdentitiesType = CloneServiceIdentitiesType;
var CloneTokensType = {
  CLONE_TOKENS_REQUEST: 'CLONE_TOKENS_REQUEST',
  CLONE_TOKENS_LOADING: 'CLONE_TOKENS_LOADING',
  CLONE_TOKENS_SUCCESS: 'CLONE_TOKENS_SUCCESS',
  CLONE_TOKENS_FAILURE: 'CLONE_TOKENS_FAILURE'
};
exports.CloneTokensType = CloneTokensType;
var ClonePolicyType = {
  CLONE_POLICY_REQUEST: 'CLONE_POLICY_REQUEST',
  CLONE_POLICY_LOADING: 'CLONE_POLICY_LOADING',
  CLONE_POLICY_SUCCESS: 'CLONE_POLICY_SUCCESS',
  CLONE_POLICY_FAILURE: 'CLONE_POLICY_FAILURE'
};
exports.ClonePolicyType = ClonePolicyType;
var CloneNotificationType = {
  OPEN_NOTIFICATION: 'OPEN_NOTIFICATION',
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION'
};
exports.CloneNotificationType = CloneNotificationType;
var ClonePermissionDetailsType = {
  CLONE_PERMISSION_DETAILS_REQUEST: 'CLONE_PERMISSION_DETAILS_REQUEST',
  CLONE_PERMISSION_DETAILS_LOADING: 'CLONE_PERMISSION_DETAILS_LOADING',
  CLONE_PERMISSION_DETAILS_SUCCESS: 'CLONE_PERMISSION_DETAILS_SUCCESS',
  CLONE_PERMISSION_DETAILS_FAILURE: 'CLONE_PERMISSION_DETAILS_FAILURE'
};
exports.ClonePermissionDetailsType = ClonePermissionDetailsType;
var ClonePermissionActionsType = {
  CLONE_PERMISSION_ACTIONS_REQUEST: 'CLONE_PERMISSION_ACTIONS_REQUEST',
  CLONE_PERMISSION_ACTIONS_LOADING: 'CLONE_PERMISSION_ACTIONS_LOADING',
  CLONE_PERMISSION_ACTIONS_SUCCESS: 'CLONE_PERMISSION_ACTIONS_SUCCESS',
  CLONE_PERMISSION_ACTIONS_FAILURE: 'CLONE_PERMISSION_ACTIONS_FAILURE',
  CLONE_PERMISSION_ACTIONS_RESET: 'CLONE_PERMISSION_ACTIONS_RESET'
};
exports.ClonePermissionActionsType = ClonePermissionActionsType;
var clonePermissionsListType = {
  RECURSIVE_CLONE_PERMISSIONS_LIST_REQUEST: 'RECURSIVE_CLONE_PERMISSIONS_LIST_REQUEST',
  RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING: 'RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING',
  RECURSIVE_CLONE_PERMISSIONS_LIST_SUCCESS: 'RECURSIVE_CLONE_PERMISSIONS_LIST_SUCCESS',
  RECURSIVE_CLONE_PERMISSIONS_LIST_FAILURE: 'RECURSIVE_CLONE_PERMISSIONS_LIST_FAILURE',
  RECURSIVE_CLONE_PERMISSIONS_LIST_RESET: 'RECURSIVE_CLONE_PERMISSIONS_LIST_RESET',
  RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING_DISABLE: 'RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING_DISABLE'
};
exports.clonePermissionsListType = clonePermissionsListType;
var cloneRolesListType = {
  RECURSIVE_CLONE_ROLES_LIST_REQUEST: 'RECURSIVE_CLONE_ROLES_LIST_REQUEST',
  RECURSIVE_CLONE_ROLES_LIST_LOADING: 'RECURSIVE_CLONE_ROLES_LIST_LOADING',
  RECURSIVE_CLONE_ROLES_LIST_SUCCESS: 'RECURSIVE_CLONE_ROLES_LIST_SUCCESS',
  RECURSIVE_CLONE_ROLES_LIST_FAILURE: 'RECURSIVE_CLONE_ROLES_LIST_FAILURE',
  RECURSIVE_CLONE_ROLES_LIST_RESET: 'RECURSIVE_CLONE_ROLES_LIST_RESET',
  RECURSIVE_CLONE_ROLES_LIST_LOADING_DISABLE: 'RECURSIVE_CLONE_ROLES_LIST_LOADING_DISABLE'
};
exports.cloneRolesListType = cloneRolesListType;
var CloneRolesDetailsType = {
  CLONE_ROLES_DETAILS_REQUEST: 'CLONE_ROLES_DETAILS_REQUEST',
  CLONE_ROLES_DETAILS_LOADING: 'CLONE_ROLES_DETAILS_LOADING',
  CLONE_ROLES_DETAILS_SUCCESS: 'CLONE_ROLES_DETAILS_SUCCESS',
  CLONE_ROLES_DETAILS_FAILURE: 'CLONE_ROLES_DETAILS_FAILURE'
};
exports.CloneRolesDetailsType = CloneRolesDetailsType;
var LoadPolicyDataType = {
  CLONE_LOAD_POLICY_REQUEST: 'CLONE_LOAD_POLICY_REQUEST',
  CLONE_LOAD_POLICY_LOADING: 'CLONE_LOAD_POLICY_LOADING',
  CLONE_LOAD_POLICY_SUCCESS: 'CLONE_LOAD_POLICY_SUCCESS',
  CLONE_LOAD_POLICY_FAILURE: 'CLONE_LOAD_POLICY_FAILURE',
  CLONE_LOAD_POLICY_RESET: 'CLONE_LOAD_POLICY_RESET',
  OPEN_NOTIFICATION: 'OPEN_NOTIFICATION',
  CLONE_LOAD_POLICY_JSON_REQUEST: 'CLONE_LOAD_POLICY_JSON_REQUEST',
  CLONE_LOAD_POLICY_JSON_LOADING: 'CLONE_LOAD_POLICY_JSON_LOADING',
  CLONE_LOAD_POLICY_JSON_SUCCESS: 'CLONE_LOAD_POLICY_JSON_SUCCESS',
  CLONE_LOAD_POLICY_JSON_FAILURE: 'CLONE_LOAD_POLICY_JSON_FAILURE',
  CLONE_LOAD_POLICY_JSON_RESET: 'CLONE_LOAD_POLICY_JSON_RESET'
};
exports.LoadPolicyDataType = LoadPolicyDataType;
var translatedStrings = {
  policyCreatedSuccessMessage: (0, _externalization.translate)('POLICIES_MODULE.ADD_POLICY_SUCCESS'),
  inlineType: (0, _externalization.translate)('INLINE'),
  preDefinedType: (0, _externalization.translate)('PRE_DEFINED'),
  loadingPolicy: (0, _externalization.translate)('POLICIES_LOADING'),
  addingPolicy: (0, _externalization.translate)('POLICIES_MODULE.ADDING_POLICY'),
  errorGetRolesList: function errorGetRolesList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.ERROR_GET_ROLE_LIST', {
      reason: reason
    });
  },
  errorGetPermissionsList: function errorGetPermissionsList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.ERROR_GET_PERMISSION_LIST', {
      reason: reason
    });
  },
  warningGetRolesList: function warningGetRolesList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.WARNING_GET_ROLE_LIST', {
      reason: reason
    });
  },
  warningGetPermissionsList: function warningGetPermissionsList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.WARNING_GET_PERMISSION_LIST', {
      reason: reason
    });
  },
  errorGetPolicyData: function errorGetPolicyData(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.VIEW_POLICY_ERROR_MESSAGE_WITH_REASON', {
      reason: reason
    });
  }
};
exports.translatedStrings = translatedStrings;
var cloneNamePrefix = 'copy_of_';
exports.cloneNamePrefix = cloneNamePrefix;
var dateSearchCharacter = '-';
exports.dateSearchCharacter = dateSearchCharacter;
var errorNotificationTime = 3000;
exports.errorNotificationTime = errorNotificationTime;